module.exports = {
      id: "0663b467266ea07431d8656aaebcf65dwater-supply.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#0663b467266ea07431d8656aaebcf65dwater-supply.svg",
      toString: function () {
        return this.url;
      }
    }